import {
  Component,
  HostListener,
  inject,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Capacitor } from '@capacitor/core';
import { Subject } from 'rxjs';
import { marketingCookiesUpdated } from '../../../app.component';
import { BaseComponent } from '../../component-base';

interface CookieData {
  // performanceCookies: boolean;
  // functionalCookies: boolean;
  // marketingCookies: boolean;
  performanceAndMarketingCookies: boolean;
}

export const openCookiesDialog: Subject<void> = new Subject<void>();

@Component({
  selector: 'app-cookie-manager',
  templateUrl: './cookie-manager.component.html',
  styleUrl: './cookie-manager.component.scss',
})
export class CookieManagerComponent
  extends BaseComponent
  implements OnInit, OnDestroy
{
  private STORAGE_KEY = 'C_SETTINGS';
  readonly fb = inject(FormBuilder);
  readonly cookieForm = this.fb.group({
    // performanceCookie: [false],
    // functionalCookie: [false],
    // marketingCookie: [false],
    performanceAndMarketingCookies: [false],
  });

  public showDialog = false;
  public showBar = false;
  public isOnApp = false;
  public openCookiesDialogSubscription;

  constructor() {
    super();

    this.openCookiesDialogSubscription = openCookiesDialog.subscribe(() => {
      this.openDialog();
    });
  }

  override ngOnDestroy(): void {
    super.ngOnDestroy();
    this.openCookiesDialogSubscription.unsubscribe();
  }

  public override async ngOnInit(): Promise<void> {
    await super.ngOnInit();

    if (!localStorage.getItem(this.STORAGE_KEY)) {
      this.showBar = true;
    }

    // if there is a logged in user on first start and we are on mobile, then register push token
    if (this.nativeAppService.isNativePlatform()) {
      this.isOnApp = true;
    }
  }

  public acceptAll() {
    this.showBar = false;
    this.showDialog = false;

    this.cookieForm.setValue({
      // functionalCookie: true,
      // marketingCookie: true,
      // performanceCookie: true,
      performanceAndMarketingCookies: true,
    });

    this.updateInStorage();
  }

  public acceptPartial() {
    this.updateInStorage();
    this.showBar = false;
    this.showDialog = false;
  }

  public openDialog() {
    this.showBar = false;
    this.showDialog = true;
  }

  public cancelDialog() {
    this.showBar = true;
    this.showDialog = false;
  }

  private updateInStorage() {
    const cookieData: CookieData = {
      // functionalCookies: this.cookieForm.value.functionalCookie!,
      // marketingCookies: this.cookieForm.value.marketingCookie!,
      // performanceCookies: this.cookieForm.value.performanceCookie!,
      performanceAndMarketingCookies:
        this.cookieForm.value.performanceAndMarketingCookies!,
    };
    localStorage.setItem(this.STORAGE_KEY, JSON.stringify(cookieData));
    marketingCookiesUpdated.next();
  }

  @HostListener('keydown.escape', ['$event.target'])
  onEscape() {
    this.cancelDialog();
  }
}
